export { default } from './VedaemLanding';
